/**
 * Polyfill for ReactDOM.findDOMNode which was removed in React 19.
 * This is needed for Material-UI v4 compatibility with React 19.
 * 
 * WARNING: This is a temporary workaround. The proper fix is migrating to MUI v5+.
 */
import ReactDOM from 'react-dom';

if (!ReactDOM.findDOMNode) {
  ReactDOM.findDOMNode = function findDOMNode(componentOrElement) {
    if (componentOrElement == null) {
      return null;
    }
    // If it's already a DOM node, return it
    if (componentOrElement.nodeType === 1) {
      return componentOrElement;
    }
    // If it has a ref to a DOM node
    if (componentOrElement._reactInternals || componentOrElement._reactInternalFiber) {
      // Try to get the DOM node from the fiber
      let fiber = componentOrElement._reactInternals || componentOrElement._reactInternalFiber;
      while (fiber) {
        if (fiber.stateNode && fiber.stateNode.nodeType === 1) {
          return fiber.stateNode;
        }
        fiber = fiber.child;
      }
    }
    // Fallback: if the component has a DOM node reference
    if (componentOrElement instanceof Element) {
      return componentOrElement;
    }
    // Last resort - return null
    console.warn('findDOMNode polyfill: Could not find DOM node for component', componentOrElement);
    return null;
  };
}
